// ** Redux
import { createAsyncThunk } from "@reduxjs/toolkit";

// ** Helpers
import { createApiCall } from "helpers/createApiCall";

// ############################################################

export const getUser = createAsyncThunk(
	"globalUser/getUser",
	createApiCall(async (props, client) => {
		const setUser = props?.setUser || false;

		const enableTests = props?.enableTests || false;

		let config = {};

		if (enableTests) {
			config = {
				headers: {
					Accept: "application/api.1.1+json",
					"Datezone-Research": Buffer.from(
						JSON.stringify({
							type:
								props?.version === "onlyDark"
									? 0
									: props?.version === "darkAndLight"
									? 1
									: 999,
							isModal: props?.isModal ? 1 : 0,
							login: 1,
						})
					).toString("base64"),
				},
			};
		}

		const response = await client.get(`/user`, config);
		return { result: response.data, setUser };
	})
);

// ############################################################
